// IndexedDB ラッパ。字幕・メタ・辞書・vocab・再生状態・設定を持つ。
// メディア本体（音声/動画）は容量が大きいため OPFS 側（opfs.js）に保存する。
import { openDB } from 'idb'

const DB_NAME = 'immerso'
const DB_VERSION = 2

let _dbPromise = null

export function db() {
  if (!_dbPromise) {
    _dbPromise = openDB(DB_NAME, DB_VERSION, {
      upgrade(d, oldVersion) {
        // v2: 辞書を「複数管理」へ。dict ストアのキーを 見出し → [dictId, 見出し] の複合キーに変更。
        // 旧 v1 の単一辞書(eijiro等)はキー体系が違うので作り直す（再ダウンロードが必要）。
        if (oldVersion && oldVersion < 2 && d.objectStoreNames.contains('dict')) {
          d.deleteObjectStore('dict')
        }
        // 汎用 KV: R2 認証情報・catalog・同期マーカー等
        if (!d.objectStoreNames.contains('kv')) {
          d.createObjectStore('kv')
        }
        // 取り込み済み item の meta/bundle（key = contentHash）
        if (!d.objectStoreNames.contains('items')) {
          d.createObjectStore('items', { keyPath: 'hash' })
        }
        // 字幕トラック（key = `${hash}/${trackId}`）
        if (!d.objectStoreNames.contains('tracks')) {
          d.createObjectStore('tracks')
        }
        // 再生状態（key = hash）: pos / bookmarks / updatedAt
        if (!d.objectStoreNames.contains('state')) {
          d.createObjectStore('state')
        }
        // 保存単語（SRS）。同一性は語の小文字＝keyPath 'key'
        if (!d.objectStoreNames.contains('vocab')) {
          d.createObjectStore('vocab', { keyPath: 'key' })
        }
        // 辞書エントリ（key = 見出し語の小文字）
        if (!d.objectStoreNames.contains('dict')) {
          d.createObjectStore('dict')
        }
      },
    })
  }
  return _dbPromise
}

// --- KV ヘルパ ---
export async function kvGet(key) {
  return (await db()).get('kv', key)
}
export async function kvSet(key, val) {
  return (await db()).put('kv', val, key)
}
export async function kvDel(key) {
  return (await db()).delete('kv', key)
}
